import ko from "knockout";
import { connect, setState } from "knockout-store";
import "./app/index.js";
import routing from "./utils/routing.js";
import "hammerjs";
//import * as styles from "./main.scss"; // This method would enable treeshaking, but I'm not sure we want that here.
import "./main.scss";

const state = {
  html: ko.observable(),
  route: routing(),
  modal: ko.observable(""),
  popUp: ko.observable(""),
  storylineData: ko.observableArray([]),
  storylineDataLoading: ko.observable(false),
  searchData: ko.observableArray([]),
  searchDataLoading: ko.observable(false),
  introData: ko.observableArray([]),
  introDataLoading: ko.observable(false),
  glossaryData: ko.observable(null),
  currentPartID: ko.observable("deel_1"),
  currentChapterID: ko.observable("deel_1_hoofdstuk_1"),
  currentParagraphID: ko.observable(""),
  currentEvidenceID: ko.observable(0),
  galleryID: ko.observable(0),
  glossaryID: ko.observable(""),
  mobileSlides: ko.observableArray([]),
  mobileSlidesPosition: ko.observable(-1),
  viewsToggle: ko.observable(false),
  isMobile:
    Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    ) < 900
      ? ko.observable(true)
      : ko.observable(false),
  mobileToastChecked: ko.observable(false),
};

// refresh mobile and desktop states
const mediaWatcher = window.matchMedia("(min-width: 900px)");
const mediaCheck = (isDesktop) => {
  if (isDesktop) {
    state.isMobile(false);
  } else {
    state.isMobile(true);
  }
};
mediaWatcher.addListener(function (e) {
  mediaCheck(e.matches);
});

setState(state);

function htmlViewModel(params) {
  const vm = {};
  vm.canonical = () =>
    process.env.URL + "/" + state.route().replace(/^\/+/g, "");
  return vm;
}

if (process.env.DEBUG) {
  state.isMobile.subscribe(function (value) {
    console.log("%c isMobile: ", "background: #222; color: #00ffff", value);
  });

  state.currentPartID.subscribe(function (value) {
    console.log(
      "%c currentPartID: ",
      "background: #222; color: #bada55",
      value
    );
  });

  state.currentChapterID.subscribe(function (value) {
    console.log(
      "%c currentChapterID: ",
      "background: #222; color: #bada55",
      value
    );
  });

  state.currentParagraphID.subscribe(function (value) {
    console.log(
      "%c currentParagraphID: ",
      "background: #222; color: #bada55",
      value
    );
  });

  state.mobileSlides.subscribe(function (value) {
    console.log("%c mobileSlides: ", "background: #222; color: #bada55", value);
  });

  state.mobileSlidesPosition.subscribe(function (value) {
    console.log(
      "%c mobileSlidesPosition: ",
      "background: #222; color: #bada55",
      value
    );
  });
}

ko.applyBindings(htmlViewModel, document.documentElement);
